module.exports = __webpack_public_path__ + "img/under-maintenance-dark.9377f6fb.svg";